import api from "api";

const PATH = "/Gamificacao";

const GET_RANKING = async () => {
  try {
    const { data } = await api.get(`${PATH}/get-gamificacao`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export { GET_RANKING };
